/* eslint-disable no-underscore-dangle */
// From https://github.com/erikras/redux-form/issues/2761#issuecomment-369934818
import { Component } from 'react'
import _ from 'lodash'
import { Field as ReduxFormField } from 'redux-form'
import { validateFlow } from '../../Proposal/Common/ProposalForm/Shared/validation/validations'
import { removeNonPrintableCharParser } from '../../../lib/parser'

const enhanceNormalizeOnBlur = (props) => {
  const {
    input: { onBlur, ...input },
    _originalComponent: Comp,
    ...restProps
  } = props
  return (
    <Comp
      {...restProps}
      input={{
        ...input,
        onBlur: (event) => {
          const { normalizeOnBlur } = props
          const value = _.get(event, 'target.value', event)
          const newValue = normalizeOnBlur ? normalizeOnBlur(value) : value
          onBlur(newValue)
        }
      }}
    />
  )
}

// APACSMDESK-34006
// [P1][proposal][newListing/newProduct][compose] 所有欄位都濾掉控制字元與跳脫字元
const defaultParser = (value, name) => {
  const finalValue = removeNonPrintableCharParser(value)
  return finalValue
}

/**
 * this is to solve the infinite loop issue caused by validation
 * https://github.com/erikras/redux-form/issues/4017
 * */
export class FieldCreator extends Component {
  validate = (...args) => {
    const propValidate = _.get(this.props, 'validate')
    const validateFunc = Array.isArray(propValidate) ? validateFlow(...propValidate) : propValidate
    return validateFunc && validateFunc(...args)
  }

  parse = (value, name) => {
    const propParse = _.get(this.props, 'parse')
    const parsedValue = defaultParser(value, name)
    if (propParse) {
      const finalValue = propParse(parsedValue, name)
      return finalValue
    }
    return parsedValue
  }

  render () {
    const props = this.props
    const { component, normalizeOnBlur } = props
    if (normalizeOnBlur) {
      return (
        <ReduxFormField
          {...props}
          validate={this.validate}
          parse={this.parse}
          normalizeOnBlur={normalizeOnBlur}
          component={enhanceNormalizeOnBlur}
          _originalComponent={component}
        />
      )
    }
    return (
      <ReduxFormField
        component={component}
        {...props}
        validate={this.validate}
        parse={this.parse}
      />
    )
  }
}

export default FieldCreator
